import { useMutation, useQueryClient } from '@tanstack/react-query';
import { applyCoupon } from '../../api/apiStorefront';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const mergeCouponIntoCart = (cache, payload) => {
  if (!cache) return cache;
  const prev = cache?.data?.data || {};
  const subtotal = Number(payload.subtotal ?? prev.subtotal) || 0;
  const discount = Number(payload.discount) || 0;
  const totalFromPayload = payload.total != null ? Number(payload.total) : null;
  const prevShipping = Number(prev.shipping_total ?? prev.shipping) || 0;
  const prevTax = Number(prev.tax_total ?? prev.tax) || 0;
  const total = Number.isFinite(totalFromPayload)
    ? totalFromPayload
    : Math.max(0, subtotal + prevTax + prevShipping - discount);

  return {
    ...cache,
    data: {
      ...cache.data,
      data: {
        ...prev,
        subtotal,
        discount,
        discount_total: discount,
        total,
        grand_total: total,
        coupon: payload.coupon || prev.coupon,
      },
    },
  };
};

export const useApplyCoupon = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (code) => applyCoupon(code),
    onSuccess: (response) => {
      const body = response?.data;
      const payload = body?.data;

      if (!body?.success || !payload?.valid) {
        toast.error(body?.message || t('cart.couponError', 'Invalid coupon code'));
        return;
      }

      queryClient.setQueryData(['cart'], (old) => mergeCouponIntoCart(old, payload));
      toast.success(body.message || t('cart.couponSuccess', 'Coupon applied successfully!'));
    },
    onError: (error) => {
      const message = error?.response?.data?.message || t('cart.couponError', 'Failed to apply coupon');
      toast.error(message);
    },
  });
};
